module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-unocked-1bc9882fc1b70a6659f66115496cd633.svg";